export type CountryStats = {
  count: number;
  name: string;
  countryCode: string;
  averageRating: number;
  numberOfRatings: number;
};

const getCountriesStats = (list: HumboList, reviews: Review[]) => {
  const countriesStats: {[countryCode: string]: CountryStats} = {};

  const reviewsByPlaceId = reviews.reduce((acc, review) => {
    if (!review.place) return acc;

    acc[review.place] = review;

    return acc;
  }, {} as any);

  for (const placeEntry of list.places) {
    const countryCode = placeEntry?.place?.countryCode;
    const review: Review = reviewsByPlaceId[placeEntry?.place?._id];

    if (!countryCode || !review) continue;

    if (!countriesStats[countryCode]) {
      countriesStats[countryCode] = {
        count: 0,
        name: placeEntry?.place?.countryName,
        countryCode,
        averageRating: 0,
        numberOfRatings: 0
      };
    }

    countriesStats[countryCode].count += 1;

    countriesStats[countryCode].averageRating =
      (countriesStats[countryCode].averageRating * countriesStats[countryCode].numberOfRatings + review.mainRating) /
      (countriesStats[countryCode].numberOfRatings + 1);

    countriesStats[countryCode].numberOfRatings += 1;
  }

  return {countriesStats};
};

export default getCountriesStats;
